module.exports = __webpack_public_path__ + "static/media/3796.7bab13a8.jpg";